import { render, staticRenderFns } from "./rolling-stock-service-details.vue?vue&type=template&id=85a2537c&scoped=true"
import script from "./rolling-stock-service-details.vue?vue&type=script&lang=js"
export * from "./rolling-stock-service-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a2537c",
  null
  
)

export default component.exports